import React, {useEffect, useContext} from "react";

import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import Box from '@mui/material/Box'

import {Loading} from '../custom/LoadingComponent'
import {getReminderName, getDeserventiTaskName} from '../util/TypeConvertor';
import * as CustomStyles from '../styles/CustomStyles';
import AuthContext from "../context/AuthContext";
import * as RestCall from '../../utils/network/RestCalls';
import * as Consts from '../constants/Consts';
import { TaskStatus, RoleClient } from "../constants/Consts";
import * as Security from '../../utils/auth/Security';
import { getAuthorizedWorksitesForContextClient } from "../../utils/auth/Security"; 

dayjs.extend(isSameOrBefore);

export const HomePublic = () => {
    return (
        <React.Fragment>
            <br />
            <br />
            <br />
            Doriti digitizarea proceselor dumneavostra de RSVTI, SSM/PSI, Medicina Muncii? Contactati-ne...
            <br />
            <br />
            <br />
            Something awesome will show up here!!!!!
            <br />
            <br />
            Something awesome will show up here!!!!!
            <br />
            <br />
            Something awesome will show up here!!!!!
            <br />
            <br />
            <br />
        </React.Fragment>
    );
}


export const HomePrivate = (props) => {
    const authContext = useContext(AuthContext);

    const [isLoading, setIsLoading] = React.useState(false);
    const [expiredReminders, setExpiredReminders] = React.useState([]);
    const [pastDueReminders, setPastDueReminders] = React.useState([]);
    const [upcomingReminders, setUpcomingReminders] = React.useState([]);

    useEffect(() => {
        if( !Security.isSystemUser() ) {
            fetchCalendarItems();
        }
    }, []);


    const fetchCalendarItems = async () => {
        const todayDate = dayjs();
        const startDate = todayDate.subtract(6, 'week');
        const endDate = todayDate.add(2, 'week');
        const startDateStr = startDate.toISOString().slice(0,10);
        const endDateStr = endDate.toISOString().slice(0,10);


        // TODO - What to do for COREVO ADMIN
        var promiseArray = [];
        var clientId;
        var authzWorksites;

        if(Security.isUserOfClientEmployer()) {
            const myClientId = Security.getSignedInUser().generalSection.clientId;
            const myClient = props.clients.find((client) => client.id === myClientId);
            const externalProviderId = myClient.generalSection.rsvtiServiceByClientId;

            clientId = externalProviderId;
            if( Security.isSignedInUserInRole(RoleClient.UserSpecificEmployer) ) {
                authzWorksites = getAuthorizedWorksitesForContextClient();
            }
            else{
                const wsIds = [];
                for(let ws of props.worksites) {
                    wsIds.push(ws.id);
                }
                authzWorksites = wsIds;
            }
        }
        else {
            clientId = authContext.afUser.generalSection.clientId;
            authzWorksites = getAuthorizedWorksitesForContextClient();
        }

        setIsLoading(true);
        promiseArray.push(RestCall.fetchCalendarItemsForClient(clientId, authzWorksites, startDateStr, endDateStr));

        for(let subcon of authContext.subcontracted) {
            if(subcon.generalSection.active) {
                promiseArray.push(RestCall.fetchCalendarItemsForClient(subcon.generalSection.subconForClientId, subcon.generalSection.permissionedWS, startDateStr, endDateStr));
            }
        }

        var ddbCalIntems = await Promise.all(promiseArray)
                                        .then(result => result.flat())
                                        .catch(error => console.log(error))
                                        .finally(() => setIsLoading(false) );

        // expired
        const expiredRems = ddbCalIntems.filter((item) => item.type === Consts.CALENDAR_EVENT_TYPE_REMINDER)
                                    .filter((item) => dayjs(item.details.dataExpirare).isSameOrBefore(todayDate));
        const expR = getGroupedReminders(expiredRems);
        const expiredTasks = ddbCalIntems.filter((item) => item.type === Consts.CALENDAR_EVENT_TYPE_RSVTITASK)
                                    .filter((item) => item.details.activeStep > 1 && item.details.status === TaskStatus.InProgress)
                                    .filter((item) => dayjs(item.step0.scheduledDate).isSameOrBefore(todayDate));
        const expT = getGroupedTasks(expiredTasks);
        setExpiredReminders( expR.concat(expT) );

        // past due
        const pastDueRems = ddbCalIntems.filter((item) => item.type === Consts.CALENDAR_EVENT_TYPE_REMINDER)
                                        .filter((item) => dayjs(item.details.dataReminder).isSameOrBefore(todayDate) &&
                                                     dayjs(item.details.dataExpirare).isAfter(todayDate) && 
                                                     !item?.scheduling?.isScheduled
                                            );
        const pastDueR = getGroupedReminders(pastDueRems);
        setPastDueReminders( pastDueR );

        // upcoming
        const upcomingRems = ddbCalIntems.filter((item) => item.type === Consts.CALENDAR_EVENT_TYPE_REMINDER)
                                         .filter((item) => dayjs(item.details.dataReminder).isAfter(todayDate) &&
                                                    !item?.scheduling?.isScheduled
                                            );
        const upcomingR = getGroupedReminders(upcomingRems);
        const upcomingTasks = ddbCalIntems.filter((item) => item.type === Consts.CALENDAR_EVENT_TYPE_RSVTITASK)
                                    .filter((item) => item.details.activeStep > 1 && item.details.status === TaskStatus.InProgress)
                                    .filter((item) => dayjs(item.step0.scheduledDate).isAfter(todayDate));
        const upcomingT = getGroupedTasks(upcomingTasks);
        setUpcomingReminders( upcomingR.concat(upcomingT) );
    }


    const getGroupedReminders = (reminderArray) => {
        const remMap = new Map();
        reminderArray.forEach((rem) => {
            const key = rem.extra.employerId + '-' + rem.extra.worksiteId + '-' + rem.details.type;
            if(remMap.has(key)) {
                const event = remMap.get(key);
                event.count = event.count + 1;
            }
            else {
                remMap.set(
                    key,
                    {
                        count: 1,
                        location: rem.extra.employerName + ' - ' + rem.extra.worksiteName,
                        remType: 'Reminder ' + getReminderName(rem.details.type)
                    }
                );
            }
        });

        return Array.from(remMap.values());
    }


    const getGroupedTasks = (taskArray) => {
        const remMap = new Map();
        taskArray.forEach((task) => {
            const key = task.step1.employerId + '-' + task.step1.worksiteId + '-' + task.details.type;
            if(remMap.has(key)) {
                const event = remMap.get(key);
                event.count = event.count + 1;
            }
            else {
                remMap.set(
                    key,
                    {
                        count: 1,
                        location: task.step1.employerName + ' - ' + task.step1.worksiteName,
                        remType: 'Task ' + getDeserventiTaskName(task.details.type)
                    }
                );
            }
        });

        return Array.from(remMap.values());
    }

    if(isLoading) {
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else {
        return (
            <Container maxWidth="xl" >
                <br />
                <br />

                {Security.isSystemUser() ? 'Nothing to display for Platform users yet....' : ''}

                <Grid container spacing={0} sx={CustomStyles.gridStyles}>

                    {
                        expiredReminders.length === 0 ?
                        <React.Fragment></React.Fragment> 
                            : 
                        <React.Fragment>
                            <Grid item xs={12}>
                                <ErrorOutlineIcon key={Math.random()} color="error" fontSize="large" sx={{mb: 1}} /> Expirate!!!!
                            </Grid>
                            {expiredReminders.map((value) => (
                                <React.Fragment key={Math.random()}>
                                    <Grid item xs={1}>
                                        {value.count}
                                    </Grid>
                                    <Grid item xs={3}>
                                        {value.remType}
                                    </Grid>
                                    <Grid item xs={8}>
                                        {value.location}
                                    </Grid>
                                </React.Fragment>
                            ))}
                            <Grid item xs={12}> &nbsp; </Grid>
                        </React.Fragment>
                    }

                    {
                        pastDueReminders.length === 0 ?
                        <React.Fragment></React.Fragment> 
                            : 
                        <React.Fragment>
                            <Grid item xs={12}>
                                <WarningAmberIcon key={Math.random()} color="warning" fontSize="large" sx={{mb: 1}} /> Data Reminder depasita
                            </Grid>
                            {pastDueReminders.map((value) => (
                                <React.Fragment key={Math.random()}>
                                    <Grid item xs={1}>
                                        {value.count}
                                    </Grid>
                                    <Grid item xs={3}>
                                        {value.remType}
                                    </Grid>
                                    <Grid item xs={8}>
                                        {value.location}
                                    </Grid>
                                </React.Fragment>
                            ))}
                            <Grid item xs={12}> &nbsp; </Grid>
                        </React.Fragment>
                    }

                    {
                        upcomingReminders.length === 0 ?
                        <React.Fragment></React.Fragment> 
                            : 
                        <React.Fragment>
                            <Grid item xs={12}>
                                <CheckCircleOutlineIcon key={Math.random()} color="success" fontSize="large" sx={{mb: 1}} /> De procesat in curand
                            </Grid>
                            {upcomingReminders.map((value) => (
                                <React.Fragment key={Math.random()}>
                                    <Grid item xs={1}>
                                        {value.count}
                                    </Grid>
                                    <Grid item xs={3}>
                                        {value.remType}
                                    </Grid>
                                    <Grid item xs={8}>
                                        {value.location}
                                    </Grid>
                                </React.Fragment>
                            ))}
                            <Grid item xs={12}> &nbsp; </Grid>
                        </React.Fragment>
                    }

                </Grid>
            </Container>
        );
    }
}